import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { useCreateApiCall } from "hooks/useCreateApiCall";

export const useRegions = () => {
  const { createApiCall } = useCreateApiCall();
  const [regionsOptions, setRegionsOptions] = useState(null);

  const loadData = createApiCall(async () => {
    const result = await API.get("restApi", "/regions", {});
    const options = (result?.Items ?? []).reduce(
      (acc, { id, label }) => ({ ...acc, [id]: label }),
      {}
    );

    setRegionsOptions(options);
  });

  const getRegionById = (id) => regionsOptions?.[id] ?? "";

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    regionsOptions,
    setRegionsOptions,
    refreshRegionsOptions: loadData,
    getRegionById,
  };
};
